// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningPopup_container__WV1Da","title":"WarningPopup_title__2Qise","footer":"WarningPopup_footer__gvLPr"};